import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import CreateStudents from "../manageStudents/CreateStudents";
import ViewBatchStudents from "../manageStudents/ViewBatchStudents";
import Loader from "../../../Loader";
import BulkUploadMain from "./bulkUpload/BulkUploadMain";
import { useParams } from "react-router-dom";
import ResourcesMain from "./resources/ResourcesMain";

const ViewBatch = ({
  batchDetails,
  setBatchDetails,
  setSelectedUserIds,
  selectedUserIds,
  createbatchFlag,
  setCreateBatchFlag,
  setStudentsData,
  studentsData,
  onAssignGuide,
  onAssignMockInterview,
}) => {
  const { id } = useParams();
  const [selectedBatch, setSelectedBatch] = useState(id ?? null);
  const [loading, setLoading] = useState(false);
  const [refressGetApi, setRefressGetApi] = useState(0);
  const [activeTab, setActiveTab] = useState("1");

  const items = [
    {
      key: "1",
      label: "All Students",
      children: activeTab === "1" && (
        <ViewBatchStudents
          selectedBatch={selectedBatch}
          setCreateBatchFlag={setCreateBatchFlag}
          setRefressGetApi={setRefressGetApi}
          refressGetApi={refressGetApi}
          setLoading={setLoading}
          batchDetails={batchDetails}
          setBatchDetails={setBatchDetails}
          setSelectedUserIds={setSelectedUserIds}
          selectedUserIds={selectedUserIds}
          studentsData={studentsData}
          setStudentsData={setStudentsData}
          onAssignGuide={onAssignGuide}
          onAssignMockInterview={onAssignMockInterview}
        />
      ),
    },
    {
      key: "2",
      label: "Bulk Upload",
      children: activeTab === "2" && (
        <BulkUploadMain
          selectedBatch={selectedBatch}
          setCreateBatchFlag={setCreateBatchFlag}
          setLoading={setLoading}
        />
      ),
    },
    {
      key: "3",
      label: "Resources",
      children: activeTab === "3" && <ResourcesMain />,
      // children: <ResourcesTable />,
    },
  ];

  return (
    <div className="mt-2">
      <style>
        {`
        .orange-tabs .ant-tabs-tab {
          color: #667085;
          font-weight: 500;
        }
        .orange-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: #DC6803 !important;
        }
        .orange-tabs .ant-tabs-ink-bar {
          background: #DC6803 !important;
        }
        .orange-tabs .ant-tabs-tab:hover {
          color: #DC6803 !important;
        }
        .orange-tabs .ant-tabs-tab:active {
          color: #DC6803 !important;
        }
        /* Fix for the blue flash on click */
        .orange-tabs .ant-tabs-tab-btn:active {
          color: #DC6803 !important;
        }
        .orange-tabs .ant-tabs-tab:active .ant-tabs-tab-btn {
          color: #DC6803 !important;
        }
        `}
      </style>
      {loading && <Loader />}
      {createbatchFlag ? (
        <CreateStudents
          selectedBatch={selectedBatch}
          setCreateBatchFlag={setCreateBatchFlag}
          setRefressGetApi={setRefressGetApi}
          loading={loading}
          setLoading={setLoading}
          setActiveTab={setActiveTab}
          batchDetails={batchDetails}
        />
      ) : (
        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          items={items}
          className="orange-tabs"
        />
      )}
    </div>
  );
};

export default ViewBatch;
